import styled from 'styled-components';
import check from './img/check.png';

export const Highlights = styled.div`
	margin-top: 21px;
`;

export const Title = styled.h3`
	color: #000;
	text-align: center;
	font-size: 24px;
	font-weight: 700;
	line-height: normal;
	margin-bottom: 20px;
`;

export const List = styled.ul`
	margin: 0;

	li {
		color: #000;
		font-size: 16px;
		font-weight: 400;
		line-height: 20px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	li + li {
		margin-top: 12px;
	}

	li:before {
		content: '';
		display: block;
		width: 24px;
		height: 24px;
		background: url(${check});
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;
		margin-right: 10px;
	}
`;
